import moment from 'moment';
import PropTypes from 'prop-types';
import downloadRecording from '../../helpers/downloadRecording';
import { RecordingSource } from '../../helpers/enums';
import { userShape } from '../../helpers/propTypeShapes';
import sanitize from '../../helpers/sanitize';
import trackMixPanelEvent from '../../helpers/trackMixPanelEvent';
import useDisableVideoDownload from '../../helpers/useDisableVideoDownload';

export default function DownloadButtonLegacy({ type, namingConvention, downloadFile, newTitle }) {
  const { disableRightClickFunc, isDownloadsEnabled, tooltip } = useDisableVideoDownload();

  if (!downloadFile) {
    return null;
  }

  let fileName = '';
  let downloadURL = '';
  let eventName = 'Download recording';
  let downloadDuration = downloadFile?.durationSeconds || null;

  // setting file name for download URL param
  const dateFormat = 'YYYY-MM-DD h-mm-ss a';
  switch (namingConvention) {
    case RecordingSource.HOST:
      fileName = `${newTitle || downloadFile.title} - Host - ${downloadFile.user?.name} - ${moment(
        downloadFile.startedAt
      ).format(dateFormat)}.mp4`;
      break;
    case RecordingSource.GUEST:
      fileName = `${newTitle || downloadFile.title} - Guest - ${downloadFile.user?.name} - ${moment(
        downloadFile.startedAt
      ).format(dateFormat)}.mp4`;
      break;
    case RecordingSource.CLIPS:
      fileName = `${newTitle || downloadFile.title} - ${downloadFile.user?.name} - ${moment(
        downloadFile.createdAt
      ).format(dateFormat)}.mp4`;
      eventName = 'Download clip';
      downloadDuration = downloadFile?.durationMillis ? downloadFile?.durationMillis / 1000 : null;
      break;
    default:
      fileName = `${downloadFile.title}`;
  }

  // setting download URL
  if (namingConvention === RecordingSource.HOST || namingConvention === RecordingSource.GUEST) {
    if (downloadFile.outfile && downloadFile.outfile !== null) {
      downloadURL = new URL(downloadFile.outfile);
    } else {
      downloadURL = downloadFile.m3u8Url;
    }

    if (downloadFile.outfile && downloadFile.outfile.includes('sl-recording-clips')) {
      const downloadUrl = new URL(window.CONFIG.recordingClipsDownloadUrl);
      downloadURL.hostname = downloadUrl.host;
    }
  } else {
    if (downloadFile.file) {
      downloadURL = new URL(downloadFile.file);
    }
    if (downloadFile.file && downloadFile.file.includes('cc-video-processed')) {
      const downloadUrl = new URL(window.CONFIG.assetDownloadUrl);
      downloadURL.hostname = downloadUrl.host;
    }
  }

  return (
    <li className="broadcast-option download" data-for={`${type}-tooltip`} data-tip={tooltip}>
      <button
        disabled={!isDownloadsEnabled}
        type="button"
        onContextMenu={disableRightClickFunc}
        onClick={() => {
          trackMixPanelEvent(eventName, { Duration: downloadDuration });
          downloadRecording(`${downloadURL.href}?filename=${encodeURIComponent(sanitize(fileName))}`);
        }}
        aria-label="Download video"
      />
    </li>
  );
}
DownloadButtonLegacy.defaultProps = {
  namingConvention: '',
};

DownloadButtonLegacy.propTypes = {
  downloadFile: PropTypes.shape({
    createdAt: PropTypes.number,
    durationMillis: PropTypes.number,
    durationSeconds: PropTypes.number,
    file: PropTypes.string,
    m3u8Url: PropTypes.string,
    outfile: PropTypes.string,
    title: PropTypes.string.isRequired,
    startedAt: PropTypes.number,
    user: userShape,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
  namingConvention: PropTypes.string,
  newTitle: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};
